import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn';
export const Panel = React.forwardRef(({ className, flush = false, ...props }, ref) => (_jsx("div", { ref: ref, className: cn(
    // `rounded-panel` is 16px — the radius this comment has always claimed. It said
    // `rounded-2xl`, which is Tailwind's stock 16px but *this* preset's 32px, so every
    // card in every console was drawn at twice the design's corner. `border-subtle` is
    // the handoff's `--border-default` → `--border-subtle` correction in the same
    // place: the console draws `1px solid var(--border-subtle)` on 40 cards and
    // `--border-default` on 11 controls, and this is a card.
    'rounded-panel border border-border-subtle bg-card', flush ? 'overflow-hidden' : 'p-5', className), ...props })));
Panel.displayName = 'Panel';
export function PanelHeader({ title, description, actions, className, density = 'comfortable', divider = false, }) {
    return (_jsxs("div", { className: cn('flex items-start gap-[14px]', divider ? 'border-b border-border-subtle' : 'mb-[14px]', className), children: [_jsxs("div", { className: "min-w-0", children: [_jsx("h2", { className: cn('font-bold text-foreground', density === 'compact' ? 'text-[13.5px]' : 'text-[15px]'), children: title }), description !== undefined ? (_jsx("p", { className: "mt-1 max-w-[560px] text-[12.5px] text-muted-foreground", children: description })) : null] }), actions !== undefined ? _jsx("div", { className: "ml-auto shrink-0", children: actions }) : null] }));
}
/**
 * The small uppercase label that titles a section inside a panel — "Their money", "Team
 * (read-only)", "Delivery failures", "Live preview". Seventeen occurrences in the prototype,
 * all with the same 10.5px / 0.12em / 700 treatment.
 */
export function SectionLabel({ children, className, }) {
    return (_jsx("p", { className: cn(
        // `tracking-caps` is the handoff's `--tracking-caps`, which is this same 0.12em —
        // bound to the token so the eyebrow tracking is one decision rather than a literal
        // repeated wherever an all-caps label appears.
        'text-[10.5px] font-bold uppercase tracking-caps text-muted-foreground', className), children: children }));
}
/**
 * The muted note panel the design closes several screens with — governance copy, caveats, the
 * "append-only" reminder. Ivory rather than white, so it reads as commentary on the panel above
 * rather than another panel of content.
 */
export function NotePanel({ children, className, }) {
    return (_jsx("div", { className: cn(
        // Radius, border and text colour corrected with `Panel`'s — same 16px corner, same
        // `--border-subtle`, and `--text-body` rather than an 80% tint of `--foreground`,
        // which is a token the handoff defines and this was approximating.
        //
        // The ivory fill is **not** a correction and is left alone: the design draws this
        // panel white, and ivory is this component's own documented choice above.
        'rounded-panel border border-border-subtle bg-muted/40 px-[18px] py-4 text-[12.5px] leading-[1.6] text-text-body', className), children: children }));
}
//# sourceMappingURL=console-panel.js.map